import accountingModule from './modules/accounting'
import adminModule from './modules/admin'
import authGuard from './authGuard'
import capabilitiesModule from './modules/capabilities'
import communicationsModule from './modules/communications'
import councilMeetingModule from './modules/councilMeeting'
import eventsModule from './modules/events'
import facilitiesModule from './modules/facilities'
import feedbacksModule from './modules/feedbacks'
import Home from '../components/Home'
import internalsModule from './modules/internals'
import erpModule from './modules/erp'
import Login from '@pages/security/Login'
import managementModule from './modules/management'
import meetingsModule from './modules/meetings'
import monitoringModule from './modules/monitoring'
import operationsModule from './modules/operations'
import petitionsModule from './modules/petitions'
import generalReportsModule from './modules/generalReports'
import preselectionModule from './modules/preselection'
import reporting from './modules/reporting'
import reportsModule from './modules/reports'
import resourcesModule from './modules/resources'
import securityModule from './modules/security'
import marketingModule from './modules/marketing'
import vendorsModule from './modules/vendors'
import Welcome from '@pages/Welcome'
import administrativeTasks from './modules/administrativeTasks'
import novaRoutes from './modules/nova'
import guardIndicators from './modules/guardIndicators'
import marketplaceModule from './modules/marketplace'
import requirementsModule from './modules/requirements'
import customerServiceModule from './modules/customerService'
import errorsModule from './modules/errors'
// Security
const MeetingLogin = () => import('@pages/security/MeetingLogin')
const SurveyLogin = () => import('@pages/security/SurveyLogin')
const CouncilMeetingLogin = () => import('@pages/security/CouncilMeetingLogin')
const PasswordReset = () => import('@pages/security/PasswordReset')
// const AdminManagementReport = () => import('@pages/security/ManagementReportLogin')
const AdminManagementReport = () => import('@pages/generalReports/AdminManagementReport')

export default [
    {
        path: '/',
        component: Login,
        name: 'login',
        props: true,
    },
    {
        path: '/meeting-login',
        component: MeetingLogin,
        name: 'meetingLogin',
        props: true,
    },
    {
        path: '/survey-login',
        component: SurveyLogin,
        name: 'surveyLogin',
        props: true,
    },
    {
        path: '/council-meeting-login',
        component: CouncilMeetingLogin,
        name: 'councilMeetingLogin',
        props: true,
    },
    {
        path: '/password-reset',
        component: PasswordReset,
        name: 'passwordReset',
    },
    {
        path: '/venues/:venueId/management-report',
        component: AdminManagementReport,
        name: 'adminManagementReport',
        props: true,
    },
    // {
    //     path: '/management-report-login',
    //     component: AdminManagementReport,
    //     name: 'adminManagementReport',
    //     props: true,
    // },
    {
        path: '/app',
        component: Home,
        children: [
            {
                path: '/',
                component: Welcome,
                name: 'home',
            },
            accountingModule,
            administrativeTasks,
            adminModule,
            capabilitiesModule,
            communicationsModule,
            customerServiceModule,
            erpModule,
            eventsModule,
            facilitiesModule,
            generalReportsModule,
            guardIndicators,
            internalsModule,
            managementModule,
            marketingModule,
            marketplaceModule,
            monitoringModule,
            operationsModule,
            petitionsModule,
            reporting,
            reportsModule,
            resourcesModule,
            securityModule,
            vendorsModule,
        ],
        beforeEnter: authGuard,
    },
    councilMeetingModule,
    feedbacksModule,
    meetingsModule,
    novaRoutes,
    preselectionModule,
    requirementsModule,
    errorsModule,
]
